import React from 'react';
import { StarIcon, BrainIcon } from 'lucide-react';
const testimonials = [{
  id: 1,
  name: 'Anna J.',
  occupation: 'Läkare, 54 år',
  text: 'Efter att ha glömt patientdetaljer allt oftare blev jag orolig för min karriär. Efter 3 veckor med Brainy kan jag nu minnas komplexa detaljer igen och min koncentration har återvänt. Det känns som att jag fått tillbaka min gamla hjärna.',
  rating: 5,
  image: 'https://randomuser.me/api/portraits/women/65.jpg'
}, {
  id: 2,
  name: 'Lars E.',
  occupation: 'Ingenjör, 62 år',
  text: 'Jag glömde ständigt var jag lagt saker och tappade tråden i samtal. Det var pinsamt och frustrerande. Efter 4 veckor med Brainy minns jag nu namn, möten och detaljer igen. Min fru har märkt en enorm skillnad.',
  rating: 5,
  image: 'https://randomuser.me/api/portraits/men/32.jpg'
}, {
  id: 3,
  name: 'Maria S.',
  occupation: 'Professor, 47 år',
  text: 'Min minnesförlust började påverka min forskning och undervisning. Efter 6 veckor med Brainy kan jag nu hålla föreläsningar utan anteckningar igen och minns mina studenters namn. Det känns som att dimman i mitt huvud har lättat.',
  rating: 5,
  image: 'https://randomuser.me/api/portraits/women/44.jpg'
}];
const Testimonials = () => {
  return <div className="bg-white rounded-lg shadow-lg p-6 md:p-8" data-id="element-255">
      <h2 className="text-2xl font-bold text-gray-800 mb-2 text-center" data-id="element-256">
        Återvunna Minnen
      </h2>
      <p className="text-center text-gray-600 mb-8" data-id="element-257">
        Från personer som återställt sitt minne med Brainy
      </p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-258">
        {testimonials.map(testimonial => <div key={testimonial.id} className="border border-gray-200 rounded-lg p-5 hover:shadow-md transition-shadow" data-id="element-259">
            <div className="flex items-center mb-4" data-id="element-260">
              <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full mr-3" data-id="element-261" />
              <div data-id="element-262">
                <div className="font-semibold" data-id="element-263">{testimonial.name}</div>
                <div className="text-sm text-gray-500" data-id="element-264">
                  {testimonial.occupation}
                </div>
              </div>
            </div>
            <div className="flex mb-3" data-id="element-265">
              {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="h-4 w-4 text-yellow-400 fill-current" data-id="element-266" />)}
            </div>
            <p className="text-gray-600 text-sm" data-id="element-267">"{testimonial.text}"</p>
            <div className="mt-4 text-xs text-blue-600 flex items-center" data-id="element-268">
              <BrainIcon className="h-3 w-3 mr-1" data-id="element-269" />
              <span data-id="element-270">Verifierad Brainy-användare</span>
            </div>
          </div>)}
      </div>
    </div>;
};
export default Testimonials;